import { render, staticRenderFns } from "./ServiceSetEstimateMoney.vue?vue&type=template&id=a4e612a2"
import script from "./ServiceSetEstimateMoney.vue?vue&type=script&lang=js"
export * from "./ServiceSetEstimateMoney.vue?vue&type=script&lang=js"
import style0 from "./ServiceSetEstimateMoney.vue?vue&type=style&index=0&id=a4e612a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports